import {
  getFirstAndLastValues,
  getFirstAndLastValuesForCurrentData,
  getLastNotNullValue,
  getsumOfValues,
  sumOfValues
} from '@/utils/analytics/growthMetricsUtils';

export const distrubutedGrowthConfig:any = {
    profile_followers: {
        plotName: "profile_followers",
        metricName: null,
        useOldData:false,
        cssIconColor: "#7239EA",
        barChartTitle: "analytics_growth.barchart_title_followers",
        doughnutChartTitle: "analytics_growth.doughnut_chart_title_followers",
        GetGrowthValues: getFirstAndLastValuesForCurrentData,
        getFinalValue: getLastNotNullValue,
        title: "analytics_growth.followers",
        tableChartColumns: [
            {
                key: "platform",
                label: "platform",
                align: "start",
                isNumeric: false,
                showGrowthArrow: false
            },
            {
                key: "followers",
                label: "analytics_growth.followers",
                align: "end",
                isNumeric: true,
                showGrowthArrow: true
            },
            {
                key: "metric_growth_followers",
                label: "analytics_growth.growth_followers",
                align: "end",
                isNumeric: true,
                showGrowthArrow: true,
                blurGrowthIndicator: false
            },
            {
                key: "metric_growth_followers_rate",
                label: "analytics_growth.growth_followers_rate",
                align: "end",
                isNumeric: true,
                showGrowthArrow: true,
                blurGrowthIndicator: false,
                showPercentage:true
            },
        ],

        
    },
    post_reach: {
        plotName: "post_reach",
        metricName: null,
        cssIconColor: "#7239EA",
        useOldData:true,
        useReachFunction: true,
        GetGrowthValues: sumOfValues,
        getFinalValue: sumOfValues,
        title: "analytics_growth.reach",
        barChartTitle: "analytics_growth.barchart_title_reach",
        doughnutChartTitle: "analytics_growth.doughnut_chart_title_reach",
        tableChartColumns: [
            {
                key: "platform",
                label: "platform",
                align: "start",
                isNumeric: false,
                showGrowthArrow: false
            },
            {
                key: "metric_name",
                label: "analytics_growth.reach",
                align: "end",
                isNumeric: true,
                showGrowthArrow: true
            },
            {
                key: "metric_growth_name",
                label: "analytics_growth.growth_reach",
                align: "end",
                isNumeric: true,
                showGrowthArrow: true,
                blurGrowthIndicator: false,
                showPercentage:false
            },
            {
                key: "metric_growth_name_rate",
                label: "analytics_growth.metric_growth_name_rate",
                align: "end",
                isNumeric: true,
                showGrowthArrow: false,
                blurGrowthIndicator: false,
                showPercentage:true
               
            },
        ],

        
    },
    post_impressions: {
        plotName: "post_impressions",
        metricName: null,
        cssIconColor: "#7239EA",
        useOldData:true,
        useReachFunction: true,
        GetGrowthValues: sumOfValues,
        getFinalValue: sumOfValues,

        title: "analytics_growth.impressions",
        barChartTitle: "analytics_growth.barchart_title_impressions",
        doughnutChartTitle: "analytics_growth.doughnut_chart_title_impressions",
        tableChartColumns: [
            {
                key: "platform",
                label: "platform",
                align: "start",
                isNumeric: false,
                showGrowthArrow: false
            },
            {
                key: "metric_name",
                label: "analytics_growth.impressions",
                align: "end",
                isNumeric: true,
                showGrowthArrow: true
            },
            {
                key: "metric_growth_name",
                label: "analytics_growth.growth_impressions",
                align: "end",
                isNumeric: true,
                showGrowthArrow: true,
                blurGrowthIndicator: false,
                showPercentage:false
            },
            {
                key: "metric_growth_name_rate",
                label: "analytics_growth.metric_growth_name_rate",
                align: "end",
                isNumeric: true,
                showGrowthArrow: false,
                blurGrowthIndicator: false,
                showPercentage:true
            },
        ],

        
    },
    post_reactions: {
        plotName: "post_reactions",
        metricName: null,
        cssIconColor: "#7239EA",
        useOldData:true,
        useReachFunction: true,
        GetGrowthValues: sumOfValues,
        getFinalValue: sumOfValues,
        title: "analytics_growth.reactions",
        barChartTitle: "analytics_growth.barchart_title_reactions",
        doughnutChartTitle: "analytics_growth.doughnut_chart_title_reactions",
        tableChartColumns: [
            {
                key: "platform",
                label: "platform",
                align: "start",
                isNumeric: false,
                showGrowthArrow: false
            },
            {
                key: "metric_name",
                label: "analytics_growth.reactions",
                align: "end",
                isNumeric: true,
                showGrowthArrow: true
            },
            {
                key: "metric_growth_name",
                label: "analytics_growth.growth_reactions",
                align: "end",
                isNumeric: true,
                showGrowthArrow: true,
                blurGrowthIndicator: false,
                showPercentage:false
            },
            {
                key: "metric_growth_name_rate",
                label: "analytics_growth.metric_growth_name_rate",
                align: "end",
                isNumeric: true,
                showGrowthArrow: false,
                blurGrowthIndicator: false,
                showPercentage:true
            },
        ],

        
    },
}